import { render, staticRenderFns } from "./TheThgBillingList.vue?vue&type=template&id=7712112c&"
import script from "./TheThgBillingList.vue?vue&type=script&lang=ts&"
export * from "./TheThgBillingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports